import React, { useContext } from "react"
import "./Styles/list.scss"

import Prefecture from "../Common/FilterModal/Location/Prefecture"
import { AreaContext } from "../Common/FilterConditionsContext"
import Loader from "../Common/Loader"

const AreaList = (props) => {
  const areas = useContext(AreaContext)

  return (
    <React.Fragment>
      <h2 className="p-top-section__header">エリアからお店・施設をさがす</h2>
      <div style={{ paddingBottom: "1rem" }}>
        <Loader show={areas.length == 0} color="green" small={false} />
      </div>
      <Prefecture locations={areas} onClick={props.onClick} />
    </React.Fragment>
  )
}

export default AreaList
